// 共通ユーティリティ: 学名の著者配列抽出とラベル整形

// 著者リレーションから "姓" 優先で氏名を抽出
export function extractAuthorNames(row = {}) {
  // すでに配列があればそのまま使う
  if (Array.isArray(row._authority_authors) && row._authority_authors.length) {
    return row._authority_authors.filter(Boolean);
  }
  if (Array.isArray(row.authors_arr) && row.authors_arr.length) {
    return row.authors_arr.filter(Boolean);
  }

  // scientific_name_and_author から researcher 情報を拾う
  if (Array.isArray(row.scientific_name_and_author)) {
    const names = row.scientific_name_and_author
      .sort((a, b) => (a.author_order ?? 0) - (b.author_order ?? 0))
      .map((rel) =>
        rel.researcher?.last_name ||
        rel.researcher?.last_name_eng ||
        rel.researcher?.first_name ||
        rel.researchers?.last_name ||
        rel.researchers?.last_name_eng ||
        rel.researchers?.first_name ||
        ""
      )
      .filter(Boolean);
    if (names.length) return names;
  }

  // authors_str があれば分割
  if (typeof row.authors_str === "string" && row.authors_str.trim()) {
    const names = row.authors_str
      .split(/[;,]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (names.length) return names;
  }

  return [];
}

// 学名の簡易ラベル（ランク＋親＋著者/年）
export function formatScientificNameLabel(node = {}) {
  const rank = node.current_rank || "";
  const parentName = node._parent_label || "";
  const main = node.name_spell_valid || node.name_spell_original || node.id || "";
  const authors = extractAuthorNames(node);
  const authorYear = node.authority_year || "";
  const suffixParts = [];
  if (authors.length) suffixParts.push(authors.join(", "));
  if (authorYear) suffixParts.push(authorYear);
  const suffix = suffixParts.length ? ` [${suffixParts.join(", ")}]` : "";
  return `${rank ? `${rank}: ` : ""}${parentName ? `${parentName} ` : ""}${main}${suffix}`;
}
